import MaskedInput from 'react-text-mask';
import React from 'react';
import InputHelper from '../../helpers/input_helper';

const SsnFormatInput = ({ inputRef, onChange, onBlur, name, id, digits, ...other }) => {
  let mask = [/\d/, /\d/, /\d/, /\d/]; // last 4 by default
  if (digits === 9) {
    mask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }
  return (
    <MaskedInput
      {...other}
      id={id}
      mask={mask}
      placeholderChar={'\u2000'}
      onChange={(e) => onChange(generateSyntheticEvent(name, e.target))}
      onBlur={(e) => onBlur(generateSyntheticEvent(name, e.target))}
      onKeyDown={(e) => InputHelper.handleMaskedBackspace(e, '-')}
      guide={false}
      keepCharPositions={false}
      inputMode="numeric"
    />
  );
};

const generateSyntheticEvent = (name, target) => {
  const value = target.value.replace(/-/g, '');
  return {
    maskedValue: target.value,
    unmaskedValue: value,
    target,
    currentTarget: target,
  };
};

export default SsnFormatInput;
